export default {
  y:'0',
  x:'0',
  visible:false,
  opacity:0,
  hide:function(){
    let vm = this
    this.y ='translateY(-100%)'
    this.opacity = 0          
    setTimeout(function(){
      vm.visible = false
    },500)
    if(this.visible){
      return false
    }else{
      return true
    }
  },
  show:function(){
    let vm = this
    this.visible = true
    setTimeout(function(){
      vm.y = 'translateY(0)'  
      vm.opacity = 1
    },50);
  }
} 



// WEBPACK FOOTER //
// ./src/api/ExerciseListDialog.js